import React, { useEffect, useState } from 'react';

const FAQJsonLd = () => {
  const [jsonLd, setJsonLd] = useState(null);

  useEffect(() => {
    let mounted = true;
    fetch('/help/faq.json', { headers: { 'Accept': 'application/json' } })
      .then(res => res.ok ? res.json() : null)
      .then(data => { if (mounted) setJsonLd(data); })
      .catch(() => {});
    return () => { mounted = false; };
  }, []);

  if (!jsonLd) return null;

  return (
    <script type="application/ld+json">
      {JSON.stringify(jsonLd)}
    </script>
  );
};

export default FAQJsonLd;
